import { createContext, useContext, useState, useRef } from "react";

const StateContext = createContext();

const initialState = {
    chat: false,
    cart: false,
    userProfile: false,
    notifications: false
};

export const ContextProvider = ({ children }) => {
    const [screenSize, setScreenSize] = useState(undefined);
    const [currentColor, setCurrentColor] = useState('#03C9D7');
    const [currentMode, setCurrentMode] = useState('Dark');
    const [themeSettings, setThemeSettings] = useState(false);
    const [activeMenu, setActiveMenu] = useState(true);
    const [isClicked, setIsClicked] = useState(initialState);
    const [statusKitchen, setStatusKitchen] = useState(0);
    const prevStatusKitchenRef = useRef(0);

    const setColor = (color) => {
        setCurrentColor(color);
        localStorage.setItem('colorMode', color);
    };

    const setMode = (e) => {
        setCurrentMode(e.target.value);
        localStorage.setItem('themeMode', e.target.value);
    };

    const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });

    const updateStatusKitchen = (newStatus) => {
        prevStatusKitchenRef.current = statusKitchen;
        setStatusKitchen(newStatus);
    };

    return (
        <StateContext.Provider 
            value={{ 
                screenSize, 
                setScreenSize, 
                currentColor, 
                setCurrentColor, 
                currentMode, 
                setCurrentMode, 
                themeSettings, 
                setThemeSettings, 
                activeMenu, 
                setActiveMenu, 
                isClicked, 
                setIsClicked, 
                setColor, 
                setMode, 
                handleClick, 
                initialState,
                statusKitchen,
                prevStatusKitchen: prevStatusKitchenRef.current,
                updateStatusKitchen
            }}
        >
            {children}
        </StateContext.Provider>
    );
};

export const useStateContext = () => useContext(StateContext);